import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';

// google reCaptcha
import ReCAPTCHA from 'react-google-recaptcha'

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//E-Posta Check
import emailValidator from 'email-validator'

//API
import { ogrenciForgetPassword } from '../../../apis/ogrenci';

const Index = () => {

    // google reCaptcha
    const recaptchaRef = React.createRef();
    const [recaptchaVerified, setRecaptchaVerified] = useState(false);
    const onChangeRecaptcha = (value) => {
        if (value) {
            setRecaptchaVerified(true);
        } else {
            setRecaptchaVerified(false);
        }
    };

    //Refs
    const tcRef = useRef()
    const epostaRef = useRef()

    //*******************************************STATES 
    const [tc, setTc] = useState("")
    const [eposta, setEposta] = useState("")




    //********************************************HANDEL FUNCTIONS
    const handleFormControl = () => {

        if (tc === "" || tc.length !== 11) {
            tcRef.current.focus()
            recaptchaRef.current.reset();
            setRecaptchaVerified(false)
            return toast.error("Lütfen 11 haneli T.C. Kimlik numaranızı giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }

        const emailChecking = emailValidator.validate(eposta)
        if (emailChecking === false) {
            epostaRef.current.focus()
            recaptchaRef.current.reset();
            setRecaptchaVerified(false)
            return toast.error("E-Posta adresinizi giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }

        handleSendNewPassword()

    }

    const handleSendNewPassword = async () => {
        let data = {
            ogrenciTC: tc,
            ogrenciEposta: eposta
        }
        let result = await ogrenciForgetPassword(data)
        if (result.status === 200) {
            setTc("")
            setEposta("")
            return toast.success("Yeni şifreniz e-posta adresinize gönderilmiştir.", {
                position: toast.POSITION.TOP_LEFT
            });
        } else {
            return toast.warning(result.response.data.message, {
                position: toast.POSITION.TOP_LEFT
            });
        }
    }

    return (
        <>
            <ToastContainer />
            <div className='relative mx-auto w-full max-w-sm bg-white'>
                <div>
                    <img src={process.env.PUBLIC_URL + '/images/odu-yatay-color.png'} alt='Ordu Üniversitesi' className='h-16' />
                    <h2 className="text-2xl font-semibold  leading-6 mt-6 mb-2 text-slate-600"> Merhaba, </h2>
                    <p className="leading-6 text-sm text-slate-500 mb-6"> <strong>{process.env.REACT_APP_PROJECT_LOWER_NAME}</strong> Şifremi Unuttum Ekranı</p>
                </div>
                <div className='mt-5'>
                    <div className='space-y-2'>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-500'>TC Kimlik Numaranız</label>
                            </div>
                            <div>
                                <div>
                                    <input ref={tcRef} value={tc} onChange={(e) => setTc(e.target.value)} type='text' placeholder='11 haneli vatandaşlık numaranız' className='sd-input' />
                                </div>
                            </div>
                        </div>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-500'>E-Posta</label>
                            </div>
                            <div>
                                <div>
                                    <input ref={epostaRef} value={eposta} onChange={(e) => setEposta(e.target.value)} type='text' placeholder='@posta' className='sd-input' />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-4 flex items-center justify-between'>
                        <div>
                            <Link to={'/login'} className='text-slate-600 font-semibold text-xs hover:underline'>Giriş yap</Link>
                        </div>
                    </div>
                    <div className='mt-6'>
                        <ReCAPTCHA
                            className='mb-4'
                            ref={recaptchaRef}
                            sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                            onChange={(value) => onChangeRecaptcha(value)} />
                        <button
                            disabled={!recaptchaVerified}
                            onClick={() => handleFormControl()}
                            className='text-white disabled:bg-slate-400 disabled:hover:bg-slate-400 bg-slate-600 hover:bg-slate-600/80 h-12 leading-5 px-4 py-1 w-full rounded-md border border-slate-300 focus:outline-slate-300 focus:outline-offset-2 focus:outline-dashed focus:outline-1 transition-all duration-150'>Gönder</button>
                    </div>
                    <div className='w-full mt-8 text-sm text-slate-400 text-center'>Bilgi İşlem Daire Başkanlığı {new Date().getFullYear()}</div>
                </div>
            </div>
        </>
    );
}

export default Index;
